
class LedgerAccountViewController extends MUIViewController
{

    static newInstance() : LedgerAccountViewController {
        let vc = new LedgerAccountViewController('ledger-account-view');
        vc.initWithResource('layout/ledgeraccount/LedgerAccountView.html');

        return vc;
    }

    private addButton:MUIButton = null;
    private exportButton:MUIButton = null;
    private saveButton:MUIButton = null;
    private tableView:UITableView = null;                    

    viewDidLoad(){
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, 'add-btn', 'MUIButton');
        this.addButton.setAction(this, function(){
           (AppHelper.sharedInstance() as any).showAddLedgerAccountAlert(this);
        });

        this.exportButton = MUIOutlet(this, "export-btn", "MUIButton");
        this.exportButton.setAction(this, function(){ 
            this.exportAction();
        });

        this.saveButton = MUIOutlet(this, 'save-btn', 'MUIButton');
        this.saveButton.setAction(this, function(){
            DBHelper.saveMainContext();
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);        
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        this.fetchedResultsController = null;
        this.rebuildSortedItems();
        this.tableView.reloadData();
    }
    
    private _sortedItems:LedgerAccount[] = [];

    numberOfSections(tableview){
        return 1;
    }

    numberOfRowsInSection(tableview, section){
        return this._sortedItems.length;
    }

    cellAtIndexPath(tableview, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier('LedgerAccountCell') as LedgerAccountCell;
        let item = this._sortedItems[indexPath.row];
        cell.item = item;
        cell.selectionStyle = UITableViewCellSelectionStyle.None;

        return cell;
    }

    // didSelectCellAtIndexPath(tableView, indexPath:MIOIndexPath){
    // }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this._sortedItems[indexPath.row];

        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            DBHelper.deleteObjectFromMainContext(item, true);
        }
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey('prefix', true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("LedgerAccount", sortDescriptors, null);

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;

        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    // Natural sort on `prefix` so that "400.0.2" sorts before "400.0.10".
    // The fetch keeps `prefix` as the DB sort key (server-compatible) and the
    // resulting array is re-ordered locally via the model's `sortPrefix` getter.
    private rebuildSortedItems(){
        let objs = (this.fetchedResultsController.fetchedObjects) as LedgerAccount[];
        this._sortedItems = objs.slice(0).sort(function(a:LedgerAccount, b:LedgerAccount){
            let av = a.sortPrefix;
            let bv = b.sortPrefix;
            if (av < bv) return -1;
            if (av > bv) return 1;
            return 0;
        });
    }

    controllerDidChangeContent(controller){
        this.rebuildSortedItems();
        this.tableView.reloadData();
    }

    private exportAction() {
        let coder = new DBLedgerAccountsCoder();
        coder.export();
    }
}
